import { createUseStyles } from 'react-jss';
export default createUseStyles((theme) => ({
    base: {
        fontFamily: 'Ubuntu',
        margin: 0,
        padding: 0,
        letterSpacing: 0,
        color: theme.palette.text,
    },
    header1: {
        fontSize: '40px',
        lineHeight: '40px',
    },
    header2: {
        fontSize: '30px',
        lineHeight: '34px',
    },
    header3: {
        fontSize: '24px',
        lineHeight: '28px',
    },
    header4: {
        fontSize: '21px',
        lineHeight: '22px',
    },
    content1: {
        fontSize: '18px',
        lineHeight: '18px',
    },
    content2: {
        fontSize: '15px',
        lineHeight: '18px',
    },
    content3: {
        fontSize: '12px',
        lineHeight: '13px',
    },
    link: {
        color: theme.palette.primary.regular,
        cursor: 'pointer'
    },
    light: { fontWeight: 300 },
    normal: { fontWeight: 400 },
    bold: { fontWeight: 500 },
    bolder: { fontWeight: 700 },
    italic: { fontStyle: 'italic' },
    center: { textAlign: 'center' },
    inherit: { color: 'inherit' },
    nowrap: { whiteSpace: 'nowrap' },
    primary: { color: theme.palette.primary.regular },
    secondary: { color: theme.palette.secondary.regular },
    success: { color: theme.palette.success.regular },
    warning: { color: theme.palette.warning.regular },
    danger: { color: theme.palette.danger.regular }
}));
//# sourceMappingURL=styles.js.map